var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainSection3Page2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.808058 1.05806C1.05214 0.813981 1.44786 0.813981 1.69194 1.05806L9.19194 8.55806C9.43602 8.80214 9.43602 9.19786 9.19194 9.44194L1.69194 16.9419C1.44786 17.186 1.05214 17.186 0.808058 16.9419C0.563981 16.6979 0.563981 16.3021 0.808058 16.0581L7.86612 9L0.808058 1.94194C0.563981 1.69786 0.563981 1.30214 0.808058 1.05806Z",
    fill: "#72D49B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSection3Page2);
export default __webpack_public_path__ + "static/media/MainSection3_Page2.bee1e3a2909432c36468fc39e41b2765.svg";
export { ForwardRef as ReactComponent };